import StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy from './StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy'

export default function StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy() {}

StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype = new StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy()

StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype.init = function(timeFormat, groupNameProvider, includeOtherUsersColumn) {
    StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy.prototype.init.call(this, timeFormat, groupNameProvider, includeOtherUsersColumn)
    return this
}

StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype.getDepartmentHeaderColumnWidth = function() {
    return 2
}

StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype.addDataCells = function(row) {
    this.addTimeValueCell(row, "spent")
    this.addTimeValueCell(row)
    this.addTimeValueCell(row)
    if (this.includeOtherUsersColumn) this.addTimeValueCell(row)
}

StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype.addSecondHeaderRowCells = function(secondHeaderRow) {
    this.addCreatedCell(secondHeaderRow, this.createUserHeaderCell())
    this.addCreatedCell(secondHeaderRow, this.createUserHeaderCell())
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/staffperformance/StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.js